import { render, staticRenderFns } from "./Instruction.vue?vue&type=template&id=2ec20d66&scoped=true&"
import script from "./Instruction.js?vue&type=script&lang=js&"
export * from "./Instruction.js?vue&type=script&lang=js&"
import style0 from "./Instruction.scss?vue&type=style&index=0&id=2ec20d66&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec20d66",
  null
  
)

export default component.exports